<template>
  <div v-if="tutor">
    <h1 class="common__main-title">Tutor Information</h1>
    <div class="common__main-contener">
      <div class="common__main-content">
        <div class="d-flex mb-5">
          <div
            @click="openUploadModal"
            class="tutor-img"
            :style="{ backgroundImage: `url(${tutor.userImage})` }"
          />
          <div class="tutor-content">
            <div class="form-group">
              <label>Tuter Name</label>
              <h4>{{tutor.name}}</h4>
            </div>
            <span class="tutor-info">{{tutor.id}} {{tutor.position.name}}</span>
          </div>
        </div>
        <div>
          <div class="form-group">
            <label>Nationality（国籍）</label>
            <div class="detail-text">
              {{tutor.nationality && tutor.nationality.name | fillEmpty }}
              ({{tutor.nationality && tutor.nationality.nameJapanese | fillEmpty }})
            </div>
          </div>
          <div class="form-group">
            <label>Phone Number</label>
            <div class="detail-text">{{tutor.phone1 | fillEmpty }}</div>
          </div>
          <div class="form-group">
            <label>Email1</label>
            <div class="detail-text">{{tutor.email1}}</div>
          </div>
          <div class="form-group">
            <label>Email2</label>
            <div class="detail-text">{{tutor.email2 | fillEmpty }}</div>
          </div>
          <div class="form-group">
            <label>Address</label>
            <div class="detail-text">{{tutor.address | fillEmpty }}</div>
          </div>
          <div class="form-group">
            <label>住所</label>
            <div class="detail-text">{{tutor.addressJapanese | fillEmpty }}</div>
          </div>
          <div class="form-group">
            <label>Emergency1</label>
            <div class="detail-text">{{tutor.emergencyContact1 | fillEmpty }}</div>
          </div>
          <div class="form-group">
            <label>Emergency2</label>
            <div class="detail-text">{{tutor.emergencyContact2 | fillEmpty }}</div>
          </div>
          <div class="form-group">
            <label>Birthday</label>
            <div class="detail-text">
              {{tutor.birthday && tutor.birthday.format('YYYY/MM/DD') | fillEmpty }}
            </div>
          </div>
          <div class="form-group">
            <label>Start Date - End Date</label>
            <div class="detail-text">
              {{tutor.hireDate && tutor.hireDate.format('YYYY/MM/DD') | fillEmpty }} -
              {{tutor.leaveDate && tutor.leaveDate.format('YYYY/MM/DD') | fillEmpty }}
            </div>
          </div>
          <div class="form-group">
            <label>Gender</label>
            <div class="detail-text">{{ tutor.gender | gender }}</div>
          </div>
          <div class="form-group">
            <label>Educational Background</label>
            <div class="detail-text">{{tutor.academicBackground | fillEmpty }}</div>
          </div>
          <div class="form-group">
            <label>Teaching Experience</label>
            <div class="detail-text">{{tutor.teachingExperience | fillEmpty }}</div>
          </div>
          <div class="form-group">
            <label>Total Experience</label>
            <div class="detail-text">{{tutor.totalExperience | fillEmpty }}</div>
          </div>
          <div class="form-group">
            <label>LMS UserID</label>
            <div class="detail-text">{{tutor.lmsUserId | fillEmpty }}</div>
          </div>
          <div class="form-group">
            <label>LMS AccessToken</label>
            <div class="detail-text">{{tutor.lmsToken | fillEmpty }}</div>
          </div>
          <div class="form-group">
            <label>Priority Waiting flag</label>
            <div class="detail-text">{{tutor.waitingPriority ?
          'Priority to waiting' : 'No priority to waiting'}}</div>
          </div>
          <div class="form-group">
            <label>Note</label>
            <div class="detail-text">{{tutor.note | fillEmpty }}</div>
          </div>
        </div>
        <TravelExpreses v-if="tutor" :tutor="tutor" />
        <Histories v-if="tutor" :tutor="tutor" />
      </div>

      <div class="d-flex justify-content-between">
        <b-button
          pill
          variant="secondary"
          :to="{name:'TutorList'}"
        >
          Back
        </b-button>
        <div class="d-flex">
          <b-button
            v-if="hasAuth(['senior', 'admin'])"
            pill
            variant="primary"
            :to="{name:'TutorEditTraffic'}"
            class="mr-2"
          >
            Traffic Information Register
          </b-button>
          <b-button
            v-if="hasAuth(['senior', 'admin'])"
            pill
            variant="primary"
            :to="{name:'TutorEdit'}"
          >
            Edit
          </b-button>
        </div>
      </div>
    </div>

    <UploadTutorProfileImageModal
      ref="uploadImageModal"
      @success="uploadImageSuccessed"
      @error="uploadImageFailed"
    />
    <Loading :isLoading="isLoading" />
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import _ from 'lodash'
import TravelExpreses from '@/components/parts/tutor/profile/TravelExpreses.vue'
import Histories from '@/components/parts/tutor/profile/Histories.vue'
import Loading from '@/components/parts/modal/Loading.vue'
import UploadTutorProfileImageModal from '@/components/parts/tutor/profile/UploadTutorProfileImageModal.vue'
import { Group, Tutor } from '@/store/tutors/types'
import { genderCode, Genders } from '@/store/common.types'
import { RootState } from '@/store/types'

export default Vue.extend({
  components: {
    TravelExpreses,
    Histories,
    Loading,
    UploadTutorProfileImageModal,
  },

  filters: {
    fillEmpty(val: any): string {
      return (_.isNull(val) || _.isUndefined(val)) ? '-----' : val
    },
    gender: (code: genderCode): string => Genders[code],
  },

  data(): {
    isLoading: boolean,
    } {
    return {
      isLoading: false,
    }
  },

  computed: {
    tutor(): Tutor {
      return this.$store.getters.findTutorById(this.$route.params.id)
    },

    groups(): Group[] {
      return this.$store.state.tutors.groups
    },
  },

  created() {
    this.fetch()
  },

  methods: {
    fetch() {
      if (this.isLoading) {
        return
      }

      this.$store.dispatch('getTutor', {
        tutorId: this.$route.params.id,
      }).finally(() => {
        this.isLoading = false
      })
    },

    /**
     * 画像登録モーダルの表示
     */
    openUploadModal() {
      (this.$refs.uploadImageModal as UploadTutorProfileImageModal).open()
    },

    uploadImageSuccessed() {
      (this.$refs.uploadImageModal as UploadTutorProfileImageModal).close()
      this.$bvModal.msgBoxOk('Uploaded profile image')
        .then(() => this.$router.go(0))
    },

    uploadImageFailed(error: any) {
      (this.$refs.uploadImageModal as UploadTutorProfileImageModal).close()
      const message = _.has(error, 'response') ? error.response.data.message : error.message
      this.$bvModal.msgBoxOk(`Failed: ${message}`)
    },

    hasAuth(acceptRoles: string[]): boolean {
      const auth = (this.$store.state as RootState).auth.profile?.authority
      return _.indexOf(acceptRoles, auth) !== -1
    },
  },
})
</script>

<style scoped>

.detail-text {
  display: block;
  margin-left: 10px;
  color: #214D91;
  font-weight: bold;
  font-size: 14px;
  letter-spacing: 0.5px;
  word-wrap: break-word;
}

.tutor-img {
  width: 120px;
  height:120px;
  margin-right:50px;
  background: #ACB8CA;
  background-size: cover;
  background-position: center;
  border:4px solid #fff;
  border-radius: 200px;
  cursor: pointer;
}

.tutor-content {
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.tutor-info {
  padding: 5px 10px;
  border-radius: 20px;
  background: #2E75B5;
  color: #fff;
}

</style>
